import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.768 7.23101C14.4587 6.923 13.9572 6.923 13.6478 7.23101L8.76238 12.0958L6.35216 9.6958C6.04284 9.38778 5.54132 9.38778 5.23199 9.6958C4.92267 10.0038 4.92267 10.5032 5.23199 10.8112L8.20229 13.769C8.51162 14.077 9.01313 14.077 9.32246 13.769L14.768 8.34645C15.0773 8.03843 15.0773 7.53903 14.768 7.23101Z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
